import { ApiError } from './types'

export function getMessageFromApiError(error: ApiError): string[] {
  const errors = error.response.errors?.map((entry) => entry.message)
  return errors ? ['An error occurred', ...errors] : ['An error occurred']
}
